import(/* webpackMode: "eager" */ "/home/interim/frontend/app/cooperation/page.tsx");
